import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';
import { AuthService } from './auth.service';
import { environment as env } from '../../environments/environment';
import { ToastService } from './toast.service';
import _ from 'lodash';
const localLog = console.log;

@Injectable({
  providedIn: 'root'
})
export class ClientNotificationsService {

  @Output() notifications = new EventEmitter<any>();
  private notificationsList: any[] = [];

  private pollTimerId: any;

  constructor(private http: HttpClient,
    private loadingService: LoadingService,
    private authService: AuthService,
    private toast: ToastService) {

    if (this.pollTimerId) {
      clearInterval(this.pollTimerId);
    }
    setInterval(() => {
      this.getNotifications();
    }, 1000 * 30); // Poll every 30 seconds
    //Run immediately on init
    this.getNotifications();
  }

  private _get_headers() {
    return {      withCredentials: true
    };
  }

  async getNotifications(show_loading_msg = false): Promise<any> {

    //!Only get notifications if already logged in
    if (!this.authService.is_logged_in()) {
      return;
    }

    let _id: any;
    if (show_loading_msg) {
      _id = this.loadingService.add('Loading Notifications');
    }
    try {
      let res: any = await this.http.get(
        `${env.apiUrl}/rest/client-notifications`,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      this.notificationsList = res;
      this.notifications.emit(this.notificationsList);

      if (_id) this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error getNotifications() =>', e);
      // this.toast.error('Failed to get notifications', e.message);
      if (_id) this.loadingService.remove(_id);
      return { err: e.message }
    }
  }

  async addNotification(data: any): Promise<any> {
    let _id = this.loadingService.add('Adding new notification');
    try {
      let res: any = await this.http.post(
        `${env.apiUrl}/rest/client-notifications`,
        data,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }
      this.notificationsList.unshift(res);
      this.notifications.emit(this.notificationsList);
      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      console.log('Error addNotification() =>', e);
      this.toast.error('Failed to add notification', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }

  async deleteNotification(id: string): Promise<any> {
    let _id = this.loadingService.add('Deleting notification');
    try {
      let res: any = await this.http.delete(
        `${env.apiUrl}/rest/client-notifications/${id}`,
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      // Remove from local list
      _.remove(this.notificationsList, (n: any) => n.Id === id);
      this.notifications.emit(this.notificationsList);

      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error deleteNotification() =>', e);
      this.toast.error('Failed to delete notification', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }
}
